import { css } from '@/styled-system/css';

// Base button styles
export const button = css({
  fontSize: 'sm',
  alignItems: 'center',
  bg: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  borderRadius: '4px',
  height: '32px',
  minWidth: 'fit-content',
  paddingTop: '6px',
  paddingRight: '12px',
  paddingBottom: '6px',
  paddingLeft: '12px',
  color: 'hpxBlue600',
  cursor: 'pointer',
  _focus: {
    outline: 'none',
  },
  _focusVisible: {
    outlineWidth: '1px',
    outlineStyle: 'auto',
    outlineColor: 'hpxTeal600',
    outlineOffset: '1px',
  },
});

// Button type: text
export const buttonTypeText = css({
  background: 'transparent',
  borderWidth: '0',
  borderStyle: 'none',
  fontWeight: 'bold',
  color: 'hpxGrey600',
});

// Button type: link
export const buttonTypeLink = css({
  background: 'transparent',
  borderWidth: '0',
  borderStyle: 'none',
  textDecoration: 'underline',
  color: 'hpxGrey600',
});

// Button type: primary
export const buttonTypePrimary = css({
  bg: 'hpxTeal500',
  color: 'hpxWhite',
  paddingTop: '0px',
  paddingRight: '16px',
  paddingBottom: '0px',
  paddingLeft: '16px',
  fontWeight: 'bold',
});

// Button type: primary-outline
export const buttonTypePrimaryOutline = css({
  bg: 'hpxWhite',
  color: 'hpxTeal500',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxTeal500',
  paddingTop: '0px',
  paddingRight: '16px',
  paddingBottom: '0px',
  paddingLeft: '16px',
  fontWeight: 'bold',
  _hover: {
    transitionProperty: 'all',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in-out',
    bg: 'hpxGrey100',
  },
});

// Button size: large
export const buttonLarge = css({
  height: '48px',
  width: '100%',
  lg: {
    width: '150px',
  },
});

// Button size: stretch
export const buttonStretch = css({
  height: '48px',
  width: '100%',
});

// Button state: disabled
export const buttonDisabled = css({
  fontWeight: 'normal',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  bg: 'hpxGrey100',
  color: 'hpxGrey600',
  pointerEvents: 'none',
  cursor: 'not-allowed',
});

// Button state: aria-disabled
export const buttonAriaDisabled = css({
  fontWeight: 'normal',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  bg: 'hpxGrey400',
  color: 'hpxGrey600',
  pointerEvents: 'none',
  cursor: 'not-allowed',
});

// Button state: active
export const buttonActive = css({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxTeal600',
  color: 'hpxTeal600',
  fontWeight: 'bold',
});

// Flex container for button content
export const flexContainer = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

// Dynamic flex container with custom justify-content
export const flexContainerWithJustify = (justifyContent?: string) =>
  css({
    display: 'flex',
    justifyContent: justifyContent || 'space-between',
    alignItems: 'center',
  });

// Dynamic flex container with custom align-items
export const flexContainerWithAlign = (justifyContent?: string, alignItems?: string) =>
  css({
    display: 'flex',
    justifyContent: justifyContent || 'space-between',
    alignItems: alignItems || 'center',
  });

// Icon spacing
export const icon = css({
  marginRight: '1x',
});

// Carat span spacing
export const caratSpan = css({
  paddingLeft: '4px',
});

// Carat default rotation
export const carat = css({
  transform: 'rotate(-90deg)',
});

// Carat active rotation
export const caratActive = css({
  transform: 'rotate(90deg)',
});
